import axios from 'axios';

export const apiRequest = async ({
    url,
    method = 'GET',
    data = null,
    token = null,
    setLoading = () => { },
    onSuccess = () => { },
    onError = () => { },
    setAccessToken = null, // For handling 401
    headers: extraHeaders = {}
}) => {
    if (setLoading) setLoading(true);
    try {
        const headers = {
            ...(token ? { Authorization: 'Bearer ' + token } : {}),
            ...extraHeaders
        };
        const config = {
            method,
            url,
            headers
        };
        if (data) {
            config.data = data;
        }

        const response = await axios(config);

        if (setLoading) setLoading(false);
        if (onSuccess) onSuccess(response.data);
        return response.data;
    } catch (err) {
        if (setLoading) setLoading(false);

        if (err.response) {
            if (err.response.status === 401) {
                if (setAccessToken) setAccessToken(undefined);
            } else if (err.response.status === 404) {
                console.log(`API Error - ${err.response.status} : ${err.response.statusText}`);
            } else if (err.response.status === 500) {
                console.log(`API Error - ${err.response.status} : ${err.response.statusText}`);
            } else {
                console.log(`API Error - ${err.response.status} :`, err.response.data);
            }
        }

        if (onError) onError(err);
        // throw err; // Optionally re-throw if needed, but we seem to handle it.
    }
};
